import { FETCH_VM_LIST, RESET_VM_LIST } from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const vmListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VM_LIST:
      return { list: action.payload, others: action.others };
    case RESET_VM_LIST:
      return initialState;
    default:
      return state;
  }
};

export default vmListReducer;
